const defaultState = [];

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_VENDORS':
      return action.vendors;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/vendors.js